import { jsx, Fragment } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
const FormClassesContext = createContext({});
const CasinoClassesContext = createContext({});
const CasinoBannerWelcomeContext = createContext(
  {}
);
const GridClassesContext = createContext({});
const SignUpClassesContext = createContext({});
const SignInClassesContext = createContext({});
const SpainSignUpClassesContext = createContext(
  {}
);
const GhanaSignUpClassesContext = createContext(
  {}
);
const NlSignUpClassesContext = createContext(
  {}
);
const AppCheckboxClassesContext = createContext(
  {}
);
const CookieBarClassesContext = createContext(
  {}
);
const NoticeBoxClassesContext = createContext(
  {}
);
const UISelectClassesContext = createContext(
  {}
);
const RadioButtonClassesContext = createContext(
  {}
);
const AppSelectCustomClassesContext = createContext(
  {}
);
const DropdownCustomClassesContext = createContext(
  {}
);
const EventsSectionClassesContext = createContext(
  {}
);
const CabinetHistoryClassesContext = createContext(
  {}
);
const CabinetTableClassesContext = createContext(
  {}
);
const CabinetDetailsClassesContext = createContext(
  {}
);
const FormFiltersClassesContext = createContext(
  {}
);
const AppButtonClassesContext = createContext(
  {}
);
const CashierClassesContext = createContext(
  {}
);
const DocLoaderClassesContext = createContext(
  {}
);
const DraggerScrollClassesContext = createContext(
  {}
);
const PhoneFormClassesContext = createContext(
  {}
);
const MainBannerClassesContext = createContext(
  {}
);
const AsideMenuClassesContext = createContext(
  {}
);
const TopEventsClassesContext = createContext(
  {}
);
const EventTableClassesContext = createContext(
  {}
);
const EventFactorClassesContext = createContext(
  {}
);
const UINotificationModalContext = createContext(
  {}
);
const UIModalPortalContext = createContext(
  {}
);
const CommonClassesContext = createContext({});
const NewBonusPickerContext = createContext({});
const ResponsibleGamblingPopupContext = createContext({});
const PageWrapperContext = createContext({});
const PromoCodeContext = createContext({});
const EMPTY_CONTEXT = createContext(null);
const defaultOptions = { classesOnly: true, combine: true };
const getOptions = (options) => options ? { ...defaultOptions, ...options } : defaultOptions;
const combineClasses = (data, prev) => {
  const res = { ...prev };
  data.forEach((v) => {
    Object.entries(v).forEach(([key, value]) => {
      if (!res[key]) {
        res[key] = value;
      }
      if (res[key] && !res[key].includes(value)) {
        res[key] = `${res[key]} ${value}`;
      }
    });
  });
  return res;
};
const useCustomClassesContext = ({
  context,
  value,
  shouldCombine = true
}) => {
  const safeContext = context || EMPTY_CONTEXT;
  const upperContextValue = useContext(safeContext);
  const newContext = useMemo(() => {
    if (!shouldCombine) return value;
    if (!value || upperContextValue === null) return upperContextValue;
    let data = value;
    if (!Array.isArray(data)) {
      data = [data];
    }
    return combineClasses(data, {
      ...upperContextValue
    });
  }, [JSON.stringify(upperContextValue), JSON.stringify(value), shouldCombine]);
  return {
    context: newContext
  };
};
const getValue = (contextArray) => {
  let context;
  let value;
  let options;
  const start = contextArray[0] || [];
  if (Array.isArray(start)) {
    [context, value, options] = start;
  } else {
    context = start == null ? void 0 : start.context;
    value = start == null ? void 0 : start.value;
    options = start == null ? void 0 : start.options;
  }
  options = getOptions(options);
  return [context, value, options];
};
const ContextWrapper = ({
  contextArray,
  children
}) => {
  const [context, value, options] = getValue(contextArray);
  const { classesOnly, combine } = options;
  const { context: combinedContext } = useCustomClassesContext({
    context,
    value,
    shouldCombine: classesOnly || !classesOnly && combine
  });
  if (!contextArray.length || combinedContext === null) return /* @__PURE__ */ jsx(Fragment, { children });
  return /* @__PURE__ */ jsx(context.Provider, { value: combinedContext, children: /* @__PURE__ */ jsx(ContextWrapper, { contextArray: contextArray.slice(1), children }) });
};
export {
  AppButtonClassesContext,
  AppCheckboxClassesContext,
  AppSelectCustomClassesContext,
  AsideMenuClassesContext,
  CabinetDetailsClassesContext,
  CabinetHistoryClassesContext,
  CabinetTableClassesContext,
  CashierClassesContext,
  CasinoBannerWelcomeContext,
  CasinoClassesContext,
  CommonClassesContext,
  ContextWrapper,
  CookieBarClassesContext,
  DocLoaderClassesContext,
  DraggerScrollClassesContext,
  DropdownCustomClassesContext,
  EventFactorClassesContext,
  EventTableClassesContext,
  EventsSectionClassesContext,
  FormClassesContext,
  FormFiltersClassesContext,
  GhanaSignUpClassesContext,
  GridClassesContext,
  MainBannerClassesContext,
  NewBonusPickerContext,
  NlSignUpClassesContext,
  NoticeBoxClassesContext,
  PageWrapperContext,
  PhoneFormClassesContext,
  PromoCodeContext,
  RadioButtonClassesContext,
  ResponsibleGamblingPopupContext,
  SignInClassesContext,
  SignUpClassesContext,
  SpainSignUpClassesContext,
  TopEventsClassesContext,
  UIModalPortalContext,
  UINotificationModalContext,
  UISelectClassesContext,
  combineClasses,
  useCustomClassesContext
};
